module.exports = __webpack_public_path__ + "asset/image-Property-1-Coffee-cup-2-cf6053b4527c9a1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Property-1-Coffee-cup-2.svg
// module id = HXAi
// module chunks = 0